<template>
	<div class="delivery-modes">
		<div
			v-if="showLockerDelivery"
			@click="deliveryMode = deliveryModes.LOCKER"
			class="sk-widget-alt"
			:class="{
				'delivery-mode-selected': deliveryMode == deliveryModes.LOCKER
			}"
		>
			<SkRadio
				:value="deliveryMode"
				:option="deliveryModes.LOCKER"
				:readonly="true"
			/>
			<div @click="openFoodhallPickupModal">
				<div class="delivery-mode-name">
					<i class="sk-icon-door-open-solid"></i>
					Foodhall Pickup
				</div>
				<div class="delivery-mode-description">
					{{ lockerLocation }}
				</div>
			</div>
		</div>
		<div
			v-if="showGateDelivery"
			@click="deliveryMode = deliveryModes.DIRECT_TO_LOCATION"
			class="sk-widget-alt"
			:class="{
				'delivery-mode-selected':
					deliveryMode == deliveryModes.DIRECT_TO_LOCATION
			}"
		>
			<SkRadio
				:value="deliveryMode"
				:option="deliveryModes.DIRECT_TO_LOCATION"
				:readonly="true"
			/>
			<div>
				<div class="delivery-mode-name">
					<i class="sk-icon-person-carry-box-solid"></i>
					Gate Delivery
				</div>
				<div class="delivery-mode-description">
					{{ businessDropoffLocationText }}
				</div>
			</div>
		</div>
		<GateDeliveryModal ref="gateDeliveryModal" />
		<FoodhallPickupModal ref="foodhallPickupModal" />
	</div>
</template>

<style scoped>
.sk-widget-alt {
	overflow: visible;
}

.checkout-content >>> .checkout-additional-info {
	padding: 0;
}

.delivery-modes {
	display: flex;
}

.delivery-modes .sk-widget-alt {
	display: flex;
	align-items: center;
	margin-bottom: 15px;
}

.delivery-modes .sk-widget-alt + .sk-widget-alt {
	margin-left: 5px;
}

.delivery-modes .sk-widget > div {
	padding: 15px;
}

.delivery-modes .sk-radio {
	margin-right: 0;
	width: 15px;
	height: 15px;
	padding: 0;
	margin-left: 13px;
}

.delivery-mode-name {
	font-size: 12px;
	font-weight: var(--sk-font-bold);
	color: var(--sk-grey3);
	margin-bottom: 5px;
}

.delivery-mode-name i {
	margin-right: 10px;
	font-size: 12px;
}

.delivery-mode-description {
	color: var(--sk-grey3);
	font-size: 10px;
}

.delivery-mode-selected {
	border-color: var(--gR-base-80);
}

.delivery-mode-selected .delivery-mode-name,
.delivery-mode-selected .delivery-mode-description {
	color: var(--gR-base-80);
}
</style>

<script>
import { DeliveryMode } from "@reef-os/utils/enums/deliveryMode"
import mobileResponsivenessMixin from "@/mixins/mobile-responsiveness-mixin"
import loaderMixin from "@/mixins/loader-mixin"
import SkRadio from "@/components/common/SkRadio.vue"
import GateDeliveryModal from "@/components/modals/GateDeliveryModal.vue"
import FoodhallPickupModal from "@/components/modals/FoodhallPickupModal.vue"

export default {
	name: "MultipleTypeOptions",
	mixins: [mobileResponsivenessMixin],
	components: {
		SkRadio,
		GateDeliveryModal,
		FoodhallPickupModal,
		loaderMixin
	},
	data: function () {
		return {
			mobileThresholdWidth: 900,
			deliveryModes: DeliveryMode
		}
	},
	computed: {
		deliveryMode: {
			get: function () {
				if (
					this.$store.state.deliveryMode == null &&
					!this.$store.state.isKioskFlow
				) {
					return null
				} else {
					this.sendDeliveryModeSelected()
					return this.$store.getters.deliveryMode
				}
			},
			set: function (mode) {
				this.$store.dispatch("setDeliveryMode", mode)
				if (mode == DeliveryMode.LOCKER) {
					this.$refs.foodhallPickupModal.open()
				} else {
					this.$refs.gateDeliveryModal.open()
				}
			}
		},
		lockerLocation() {
			if (this.$store.getters.businessLocation) {
				return this.$store.getters.businessLocation.name
			}
		},
		businessDropoffLocationText() {
			if (this.$store.getters.businessDropoffLocation) {
				return (
					"Gate " + this.$store.getters.businessDropoffLocation.text
				)
			}
			return "Choose Gate"
		},
		showLockerDelivery() {
			const modes = this.$store.getters.cartDeliveryModes
			if (modes) {
				return modes.find(
					(mode) => mode.deliveryMode == DeliveryMode.LOCKER
				)
			}
			return false
		},
		showGateDelivery() {
			const modes = this.$store.getters.cartDeliveryModes
			if (modes) {
				return modes.find(
					(mode) =>
						mode.deliveryMode == DeliveryMode.DIRECT_TO_LOCATION
				)
			}
			return false
		}
	},
	methods: {
		openFoodhallPickupModal() {
			this.$refs.foodhallPickupModal.open()
		},
		openGateDeliveryModal() {
			this.$refs.gateDeliveryModal.open()
		},
		sendDeliveryModeSelected() {
			this.$emit("deliveryModeSelected")
		}
	}
}
</script>
